import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { Loader2 } from "lucide-react";
import { useAuth } from "@/auth/AuthContext";
import { API_BASE } from "@/lib/apiBase";

const API = API_BASE;

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const sessionId = new URLSearchParams(location.hash.replace("#", "")).get("session_id");
    (async () => {
      try {
        const { data } = await axios.post(`${API}/auth/session`, { session_id: sessionId }, { withCredentials: true });
        setUser(data);
        navigate(data.role === "admin" ? "/admin" : data.role === "partner" ? "/portal" : "/account", { replace: true, state: { user: data } });
      } catch {
        navigate("/login", { replace: true });
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="grid min-h-screen place-items-center bg-ink" data-testid="auth-callback">
      <div className="flex items-center gap-3 text-muted">
        <Loader2 size={20} className="animate-spin text-aqua" /> Completing sign-in…
      </div>
    </div>
  );
}
